import isEqual from "lodash/isEqual";


export default {
    computed: {
        exitConfirmationRequired() {
            return !isEqual(this.initialStepState, this.currentStepState);
        }
    },
};
